module.exports = __webpack_public_path__ + "media/images/feature-5-47152177.png";